export function sqrt(x) {
    function go(n, x0) {
        const x1 = (n / x0 + x0) >> 1n;
        if (x0 === x1 || x0 === x1 - 1n) {
            return x0;
        }
        return go(n, x1);
    }
    if (x < 0n)
        throw "Square root of negative number is not supported";
    else if (x < 2n)
        return x;
    else
        return go(x, 1n);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3FydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9zcXJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxJQUFJLENBQUMsQ0FBUztJQUM1QixTQUFTLEVBQUUsQ0FBQyxDQUFTLEVBQUUsRUFBVTtRQUMvQixNQUFNLEVBQUUsR0FBRyxDQUFDLENBQUMsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQzlCLElBQUksRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRTtZQUMvQixPQUFPLEVBQUUsQ0FBQTtTQUNWO1FBQ0QsT0FBTyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBQ2xCLENBQUM7SUFFRCxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQUUsTUFBTSxpREFBaUQsQ0FBQTtTQUM5RCxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQUUsT0FBTyxDQUFDLENBQUE7O1FBQ3BCLE9BQU8sRUFBRSxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQTtBQUN2QixDQUFDIn0=